import { HTTP } from '@/api/http-common'

export default {
  getOrderLink (callback, params) {
    let url = params.publicToken + '/orders/link/' + params.orderId + '?languageId=' + params.languageId
    HTTP.get(url).then(response => {
      callback(response)
    }).catch(e => {
      if (e.response.status == '400') {
        alert('Order link not found.')
        console.log('400 products api ', params)
      } else {
        console.log(e)
      }
    })
  },
  addOrderDetail (params) {
    return new Promise((resolve, reject) => {
      HTTP.post(params.publicToken + '/order_detail', params).then(response => {
        resolve(response.data)
      }).catch(e => {
        if (e.response.status == '400') {
          reject(new Error(e.response.data))
        } else {
          reject(e)
        }
      })
    })
  },
  deleteOrderDetail (params) {
    return new Promise((resolve, reject) => {
      HTTP.delete(params.publicToken + '/orders/' + params.orderId + '/product/' + params.sku).then(response => {
        resolve(response.data)
      }).catch(e => {
        if (e.response.status == '400') {
          reject(new Error(e.response.data))
        } else {
          reject(e)
        }
      })
    })
  },
  updateOrderDetail (params) {
    return new Promise((resolve, reject) => {
      HTTP.put(params.publicToken + '/order_detail/quantity', params).then(response => {
        resolve(response.data)
      }).catch(e => {
        if (e.response.status == '400') {
          reject(new Error(e.response.data))
        } else {
          reject(e)
        }
      })
    })
  },
  updateOrderDetailNote (params) {
    return new Promise((resolve, reject) => {
      HTTP.put(params.publicToken + '/order_detail/note', params).then(response => {
        resolve(response.data)
      }).catch(e => {
        if (e.response.status == '400') {
          reject(new Error(e.response.data))
        } else {
          reject(e)
        }
      })
    })
  },
  updateOrderAddress (params) {
    return new Promise((resolve, reject) => {
      HTTP.put(params.publicToken + '/orders/address', params).then(response => {
        resolve(response.data)
      }).catch(e => {
        if (e.response.status == '400') {
          reject(new Error(e.response.data))
        } else {
          reject(e)
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/order/index.js